import React from 'react';
import Image from 'next/image';
import { ArrowUpRight } from 'lucide-react';

export default function ApproachAndPhilosophy() {
    const items = [
        {
            icon: '/images/about/icons/perfection.png',
            title: 'Human-Centric Design',
            desc: 'We believe every product should revolve around the user. Our UX/UI experts meticulously craft intuitive, accessible, and visually stunning interfaces.'
        },
        {
            icon: '/images/about/icons/innovative.png',
            title: 'Future-Ready Technology',
            desc: 'We embrace next-generation technology. From immersive spatial computing (AR/VR/MR) to sophisticated AI models, we build solutions engineered for tomorrow.'
        },
        {
            icon: '/images/about/icons/expertise.png',
            title: 'Strategic Architecture',
            desc: 'Great software requires a solid foundation. We engineer robust, scalable web and mobile applications designed to seamlessly grow alongside your ambition.'
        },
        {
            icon: '/images/about/icons/full-cycle.png',
            title: 'End-to-End Execution',
            desc: 'From the initial strategy and discovery phase to deployment and continued scaling, our dedicated team handles the entire lifecycle of your digital product.'
        },
        {
            icon: '/images/about/icons/client-success.png',
            title: 'Measurable Impact',
            desc: 'Our ultimate philosophy is simple: your success is our success. We strictly focus on delivering high-performance solutions that drive tangible business growth.'
        }
    ];

    return (
        <section className="bg-white py-20 px-6 md:px-20 lg:px-40 text-black" data-header-theme="dark">
            {/* Header */}
            <div className="flex flex-col lg:flex-row justify-between items-start mb-20 gap-10">
                <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold tracking-tight max-w-xl">
                    Approach and<br />philosophy
                </h2>

                <div className="hidden md:flex flex-col gap-2 text-sm md:text-base text-gray-800 font-medium">
                    <p>Strategy</p>
                    <p>Innovation</p>
                    <p>Execution</p>
                </div>

                <div className="hidden md:block">
                    <a href="/contact" className="inline-flex items-center gap-2 border border-black rounded-full px-6 py-3 text-sm font-bold uppercase tracking-wide hover:bg-black hover:text-white transition-all">
                        Let's Chat
                        <ArrowUpRight className="w-4 h-4" />
                    </a>
                </div>
            </div>

            {/* List */}
            <div className="flex flex-col">
                <div className="h-px bg-black w-full" />

                {items.map((item, index) => (
                    <div key={index}>
                        <div className="py-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
                            {/* Icon */}
                            <div className="md:col-span-2">
                                <div className="relative w-16 h-16 md:w-20 md:h-20">
                                    <Image
                                        src={item.icon}
                                        alt={item.title}
                                        fill
                                        className="object-contain"
                                    />
                                </div>
                            </div>

                            {/* Title */}
                            <div className="md:col-span-3">
                                <h3 className="text-2xl font-bold">{item.title}</h3>
                            </div>

                            {/* Description */}
                            <div className="md:col-span-7">
                                <p className="text-gray-700 text-lg leading-relaxed max-w-3xl">
                                    {item.desc}
                                </p>
                            </div>
                        </div>
                        <div className="h-px bg-black w-full" />
                    </div>
                ))}
            </div>

        </section>
    );
}
